import { DynamicLoad } from '@/_cactus_core/build/dynamicLoad';





import a6d163d05219589a24f0427ad7ed0c96bb from "./generated-64479bca-6897-4bba-8d64-b696972ea8fd.json";

import ac45fa3a7023d6f8a9ab606e69fe5aa93b from "./generated-f3d2235b-50a5-4a50-a4aa-bb8f40477000.json";

import a704c08187fd1d579164627c7b096887bb from "./generated-64ee7400-5b4b-4de3-a525-b5b3dbad699b.json";

import a871fba11ca951b08532808872c8d2d4ab from "./generated-314ab69a-ad62-4453-83ab-efbe557c71e2.json";

import a1bbf2f36b4c5607df4494d2230247f70b from "./generated-357a13d4-ca07-4e42-ab29-749e304d13a0.json";

import aba5ed8c1b882897bdfd95f38043f1f93b from "./generated-bddd7809-d1fd-4fcb-8634-b5de2e4ccbcb.json";

import a36f6a9c54cfcadaaeea68d83cb748982b from "./generated-b210c48d-68e3-4836-822e-fe81e3f2e1b3.json";

import a65bea3e185a749148d4a43d7e2e5570bb from "./generated-622ac970-9626-427c-9dea-3cfac9d03b86.json";

import aa0833365703fd621340e996b077c66d0b from "./generated-38bb90d6-a384-443f-9e40-513164ebd1bc.json";

import aaedd2a24b8e551b4ff030f1b1904e1d3b from "./generated-4b16d2e3-e8fb-4ea0-89da-117693975d91.json";

import a5923c439d61b01dab33f3069be66f3c9b from "./generated-89552339-8a7a-49f9-b766-a8843bc8b727.json";

import a9dbf1bde4fdc90dbed57eb31ff49953ab from "./generated-02984e4c-5226-4b0b-b49e-d82b10eb5133.json";

import a2e06c6250d09804a16c671be7255a064b from "./generated-93d2b690-7753-4da0-93ff-fcc16178d033.json";

import a6019aa4b13ac27da55201f793ad50093b from "./generated-3398ee28-da69-4ddf-9f21-274004a5c7bc.json";

import af89b17c806c7103c8409c9827765fd89b from "./generated-25549640-2069-4041-bf5f-c9c876a65497.json";

import a02e94e3e84e6599428422da0ddd9323db from "./generated-85552dbd-ec3e-4b53-a5f4-00a4cb597b62.json";

import a30af75d11f304bec5b66adb55947a236b from "./generated-de61067c-5127-4efd-95d0-96cfa1f6e43a.json";





/* eslint-disable */

export default async function(url) {
  let storeData = false;

  async function direct(jsonResult) {
    return new Promise(async function(done,err) {
      try {
        storeData = {
          headers: jsonResult.headers,
          data: jsonResult.data,
        };
        
        done(storeData);
      } catch(e) {
        err(e);
      }
    });
  }

  async function ok(cachedJson) {
    return new Promise(async function(done,err) {
      try {
        const jsonResult = await DynamicLoad(cachedJson);

        storeData = {
          headers: jsonResult.headers,
          data: jsonResult.data,
        };

        done(storeData);
      } catch(e) {
        err(e);
      }
    });
  }
  
  try {
  
  




         if(url === "/api/appearance"){
            
                    await direct(a6d163d05219589a24f0427ad7ed0c96bb);
                
        }
    


        else if(url === "/api/getlegalterm"){
            
                    await direct(ac45fa3a7023d6f8a9ab606e69fe5aa93b);
                
        }
    


        else if(url === "/api/country"){
            
                    await direct(a704c08187fd1d579164627c7b096887bb);
                
        }
    


        else if(url === "/api/crypto/all"){
            
                    await direct(a871fba11ca951b08532808872c8d2d4ab);
                
        }
    


        else if(url === "/api/bff/features"){
            
                    await direct(a1bbf2f36b4c5607df4494d2230247f70b);
                
        }
    


        else if(url === "/api/payment-providers"){
            
                    await direct(aba5ed8c1b882897bdfd95f38043f1f93b);
                
        }
    


        else if(url === "/api/bff/games/top-wins"){
            
                    await direct(a36f6a9c54cfcadaaeea68d83cb748982b);
                
        }
    


        else if(url === "/api/bff/games/last-wins"){
            
                    await direct(a65bea3e185a749148d4a43d7e2e5570bb);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=jogos-da-pg&per_page=15"){
            
                    await direct(aa0833365703fd621340e996b077c66d0b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=roleta&per_page=16"){
            
                    await direct(aaedd2a24b8e551b4ff030f1b1904e1d3b);
                
        }
    


        else if(url === "/api/undefined&per_page=undefined"){
            
                    await direct(a5923c439d61b01dab33f3069be66f3c9b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=jogos-crash&per_page=15"){
            
                    await direct(a9dbf1bde4fdc90dbed57eb31ff49953ab);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=jogos-de-aventura&per_page=15"){
            
                    await direct(aa0833365703fd621340e996b077c66d0b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=cassino-ao-vivo&per_page=15"){
            
                    await direct(a2e06c6250d09804a16c671be7255a064b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=slots&per_page=15"){
            
                    await direct(a6019aa4b13ac27da55201f793ad50093b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=jogos-novos&per_page=15"){
            
                    await direct(aa0833365703fd621340e996b077c66d0b);
                
        }
    


        else if(url === "/api/casino-games/filter?per_page=1&per_page=15"){
            
                    await direct(af89b17c806c7103c8409c9827765fd89b);
                
        }
    


        else if(url === "/api/casino-games/filter?providers[]=hacksaw&per_page=15"){
            
                    await direct(a02e94e3e84e6599428422da0ddd9323db);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=blackjack&per_page=15"){
            
                    await direct(a30af75d11f304bec5b66adb55947a236b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories%5B%5D=all"){
            
                    await direct(af89b17c806c7103c8409c9827765fd89b);
                
        }
    





  } catch(ex){
    console.log('failed to get cache',ex,url);
  }

  return storeData;
};

/* eslint-enable */